export const accountLiterals = {
  generalData: {
    accountLabel: "Unlockd Account Address",
    totalAssetsLabel: "Total Assets",
    ethValueLabel: "ETH Value",
    usdValueLabel: "USD Value",
    copiedFeedback: "Copied!",
    copyDescription: "Copy to clipboard",
  },
  qrModal: {
    title: "My Account QR Code",
    subheader:
      "Scan this QR code with an external wallet to send tokens directly to your Account",
    backButton: "Back",
  },
  myAvailableAssets: {
    title: "Assets in my Account",
    tokensLabel: "Tokens",
    nftsLabel: "NFTs",
    selectMultipleCta: "Select Multiple",
  },
  tokenRow: {
    receiveCta: "Receive",
    sendCta: "Send",
  },
  sendTokensModal: {
    title: "Send Tokens",
    subheader: "Easily transfer your tokens to another wallet",
    backCta: "Back",
    submitCta: "Send",
    loadingSubmitCta: "Loading",
  },
  uAccountNftCard: {
    borrowCtaEnabled: "Borrow",
    borrowCtaDisabled: "Secured in Loan",
    borrowCtaNotValuated: "No Pricing Data",
    withdrawCta: "Withdraw",
  },
  multipleSelectionBar: {
    selectedAssetsLabel: (amount: number) => `${amount} Selected Assets`,
    borrowCta: "Borrow",
  },
  modalWithdrawNfts: {
    title: "Withdraw Asset",
    subtitle: "Withdraw your asset from the Unlockd Account to any address",
    transferDetail: (name: string) => `Transfer "${name}" to:`,
    transferCta: "Transfer",
    cancelCta: "Cancel",
  },
  withdrawalSection: {
    title:
      "The following collections will need to be approved individually in order to lorem ipsum lorem ipsum",
    addressDescription: "Transfer assets to:",
    ctaPrimaryWithdraw: "Withdraw",
    ctaPrimaryLoading: "Loading",
    ctaPrimaryApprove: "Approve Collections",
  },
  selectedNfts: {
    title: (amount: number) => `${amount} Selected Assets`,
  },
  transfers: {
    title: "Transactions",
    txHashTitle: "Transaction Hash",
    methodTitle: "Method",
    dateTitle: "Date",
    fromTitle: "From",
    toTitle: "To",
    valueTitle: "Value",
    noTransfers: "No transactions",
  },
  nftsSection: {
    // noNftsTitle: "Ooops...",
    noNftsDescriptionL1: "Your Unlockd Account currently holds no NFTs.",
    noNftsDescriptionL2:
      "Assets used as collateral for loans will be displayed here, and after loan closure, you'll also see free assets available for withdrawal.",
    // documentationDescriptions: "our documentation.",
  },
  nftInfoPanel: {
    traitsTitle: "Traits",
  },
};
